import React, { useCallback, useRef } from "react";
import PropTypes from "prop-types";

/**
 * 연속 클릭 방지 버튼.
 * 마지막 클릭 후 delay(ms) 이내의 클릭을 무시한다.
 *
 * @example
 * <ThrottledButton onClick={handleClick} delay={500}>
 *   저장
 * </ThrottledButton>
 */
export default function ThrottledButton({ onClick, delay = 300, children, ...props }) {
    const lastClickRef = useRef(0);

    const handleClick = useCallback((e) => {
        const now = Date.now();
        if (now - lastClickRef.current < delay) return;
        lastClickRef.current = now;
        onClick?.(e);
    }, [onClick, delay]);

    return (
        <button {...props} onClick={handleClick}>
            {children}
        </button>
    );
}

ThrottledButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    delay: PropTypes.number,
    children: PropTypes.node,
};
